/* Admin: Today (AdminToday.dc.html), in the master brand: white, the ink, greys as tints of it, gold
   only for the announcement's edge. Every colour is a token (styles/tokens.css); the board's 0.55 grey
   labels are --shell-ink-60, which passes 4.5 to 1. At 1440 the 2 columns are the board's
   (1.7fr and 1fr, 24px apart); under 1100 they stack; under 760 every row stacks (answer 5). */

.td-page { display: flex; flex-direction: column; gap: 26px; min-width: 0; }
.td-grid { display: grid; grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr); gap: 24px; align-items: start; }
.td-col { display: flex; flex-direction: column; gap: 24px; min-width: 0; }

.td-card { border-radius: 14px; border: 1px solid var(--shell-ink-10); background: var(--shell-bg); overflow: hidden; }
.td-card-head { padding: 20px 24px; border-bottom: 1px solid var(--shell-ink-08); }
.td-card-head--split { display: flex; align-items: baseline; justify-content: space-between; gap: 6px 16px; flex-wrap: wrap; }
.td-h2 { margin: 0; font-size: 19px; font-weight: 800; line-height: 1.3; }
.td-card-aside { font-size: 13px; color: var(--shell-ink-60); }
.td-pad { padding: 18px 24px; }
.td-empty { margin: 0; padding: 20px 24px; font-size: 14px; line-height: 1.55; color: var(--shell-ink-60); }
.td-flush.ad-loading { padding: 0; }
.td-card ul { list-style: none; margin: 0; padding: 0; }

/* ---- Live today: the black card ------------------------------------------------------------------ */
.td-live {
  padding: 24px 26px; border-radius: 14px; background: var(--shell-ink); color: var(--on-dark);
  display: flex; align-items: center; justify-content: space-between; gap: 16px 24px;
}
.td-live-text { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.td-live-label {
  display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 700; letter-spacing: 0.12em;
  text-transform: uppercase; color: var(--on-dark-74);
}
.td-live-dot { width: 7px; height: 7px; border-radius: 4px; flex-shrink: 0; }
.td-live-title { font-size: 21px; font-weight: 700; line-height: 1.3; overflow-wrap: anywhere; }
.td-live-detail { font-size: 14px; line-height: 1.5; color: var(--on-dark-74); }
.td-live-btn {
  flex-shrink: 0; height: 44px; padding: 0 18px; border-radius: 10px; background: var(--shell-bg); color: var(--shell-ink);
  font-weight: 700; font-size: 14px; display: inline-flex; align-items: center; justify-content: center; text-decoration: none; white-space: nowrap;
}
.td-live-btn:hover { color: var(--shell-ink); background: var(--shell-tile-light); }
.ad-app .td-live-btn:focus-visible { outline-color: var(--shell-gold); }

/* ---- Needs you ---------------------------------------------------------------------------------- */
.td-job {
  display: flex; gap: 16px; padding: 18px 24px; border-bottom: 1px solid var(--shell-ink-06); align-items: flex-start;
}
.td-jobs .td-job:last-child { border-bottom: none; }
.td-job:hover { background: var(--shell-ink-025); }
.td-tick { width: 19px; height: 19px; margin: 3px 3px 3px 4px; accent-color: var(--shell-ink); flex-shrink: 0; cursor: pointer; }
/* a mastermind's own job has no tick box (it goes once it's done): the same column, empty */
.td-tick-space { width: 26px; flex-shrink: 0; }
.td-job-main { flex-grow: 1; display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.td-job-text { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.td-job--done .td-job-text { opacity: 0.45; }
.td-job-top { display: flex; align-items: center; gap: 10px; }
.td-chip {
  height: 22px; padding: 0 8px; border-radius: 6px; background: var(--shell-ink-07); color: var(--shell-ink);
  font-size: 11px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; display: inline-flex; align-items: center;
  white-space: nowrap; flex-shrink: 0;
}
.td-chip--ink { background: var(--shell-ink); color: var(--shell-on-ink); }
.td-job-title { font-size: 15px; font-weight: 700; line-height: 1.4; overflow-wrap: anywhere; min-width: 0; }
.td-job-detail { font-size: 14px; line-height: 1.55; color: var(--shell-ink-66); overflow-wrap: anywhere; }
.td-job-stamp { font-size: 13px; line-height: 1.5; color: var(--shell-ink-72); }
.td-job-msg { font-size: 13px; font-weight: 700; line-height: 1.5; overflow-wrap: anywhere; }
.td-job-msg--problem { box-shadow: inset 3px 0 0 var(--shell-gold); padding-left: 10px; }
.td-job-acts { display: flex; gap: 8px; flex-shrink: 0; flex-wrap: wrap; justify-content: flex-end; max-width: 46%; }
.td-job-link, .td-job-btn {
  height: 36px; padding: 0 14px; border-radius: 8px; font-weight: 700; font-size: 13px; display: inline-flex; align-items: center;
  justify-content: center; text-decoration: none; white-space: nowrap; line-height: 1; font-family: inherit;
}
.td-job-link { border: 1px solid var(--shell-ink-16); color: var(--shell-ink); background: var(--shell-bg); }
.td-job-link:hover { background: var(--shell-ink-03); color: var(--shell-ink); }
.td-job-btn { border: none; background: var(--shell-ink); color: var(--shell-on-ink); cursor: pointer; }
.td-job-btn--line { border: 1px solid var(--shell-ink-16); background: var(--shell-bg); color: var(--shell-ink); }
.td-job-btn:disabled { opacity: 0.55; cursor: default; }

/* what a button opens in its row */
.td-panel {
  margin-top: 4px; padding: 14px; border-radius: 10px; background: var(--shell-ink-03); display: flex; flex-direction: column; gap: 10px;
}
.td-panel-acts { display: flex; gap: 8px; flex-wrap: wrap; }
.td-panel-note { font-size: 13px; color: var(--shell-ink-60); }
.td-panel .ad-search { width: 100%; }
.td-match { display: flex; flex-direction: column; gap: 6px; }
.td-match-row {
  display: flex; flex-direction: column; align-items: flex-start; gap: 2px; padding: 10px 12px; border-radius: 9px; text-align: left;
  border: 1.5px solid var(--shell-ink-16); background: var(--shell-bg); color: var(--shell-ink); font-family: inherit; cursor: pointer;
}
.td-match-row[aria-checked="true"] { border-color: var(--shell-ink); }
.td-match-name { font-size: 14px; font-weight: 700; }
.td-match-email { font-size: 13px; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.td-job-main .ad-confirm { margin-top: 4px; }

/* ---- New this week ------------------------------------------------------------------------------ */
.td-new-row {
  display: grid; grid-template-columns: minmax(0, 1fr) 280px 90px; gap: 16px; align-items: center; padding: 14px 24px;
  border-bottom: 1px solid var(--shell-ink-06);
}
.td-new .td-new-row:last-child { border-bottom: none; }
.td-new-row:hover { background: var(--shell-ink-025); }
.td-new-who { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.td-new-name { font-size: 15px; font-weight: 700; color: var(--shell-ink); text-decoration: none; }
.td-new-name:hover { text-decoration: underline; }
.td-new-email { font-size: 13px; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.td-new-what { display: flex; align-items: center; gap: 8px; font-size: 14px; line-height: 1.45; min-width: 0; }
.td-new-what .ad-dot { align-self: center; }
.td-new-when { font-size: 13px; color: var(--shell-ink-60); justify-self: end; white-space: nowrap; }

/* ---- The right-hand cards ------------------------------------------------------------------------ */
.td-side { padding: 20px 22px; display: flex; flex-direction: column; gap: 12px; overflow: visible; }
.td-side--tight { gap: 8px; }
.td-side-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.td-h2--side { font-size: 17px; }
.td-side-line { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.td-side-line--body { font-size: 14px; line-height: 1.55; color: var(--shell-ink-62); }
.td-side-rule { font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.td-small-btn, .td-tiny-btn {
  border-radius: 8px; border: 1px solid var(--shell-ink-16); background: var(--shell-bg); color: var(--shell-ink);
  font-weight: 700; font-family: inherit; cursor: pointer; white-space: nowrap;
}
.td-small-btn { height: 32px; padding: 0 12px; font-size: 13px; }
.td-tiny-btn { align-self: flex-start; margin-top: 4px; height: 28px; padding: 0 10px; border-radius: 7px; font-size: 12px; }
.td-small-btn:hover, .td-tiny-btn:hover { background: var(--shell-ink-03); }
.td-tiny-btn:disabled { opacity: 0.55; cursor: default; }

.td-news {
  display: flex; flex-direction: column; gap: 4px; padding: 12px 14px; border-radius: 10px; border: 1px solid var(--shell-ink-10);
  box-shadow: inset 3px 0 0 var(--shell-gold);
}
.td-news-head { font-size: 14px; font-weight: 700; line-height: 1.45; overflow-wrap: anywhere; }
.td-news-line { font-size: 13px; line-height: 1.45; color: var(--shell-ink-66); overflow-wrap: anywhere; }
.td-news-meta { font-size: 12px; line-height: 1.45; color: var(--shell-ink-60); }

.td-compose { display: flex; flex-direction: column; gap: 10px; padding: 14px; border-radius: 10px; background: var(--shell-ink-03); }
.td-compose-text {
  height: 64px; padding: 10px 12px; border-radius: 8px; border: 1px solid var(--shell-ink-16); font-size: 14px; resize: vertical;
  color: var(--shell-ink); background: var(--shell-bg); font-family: inherit; line-height: 1.45; width: 100%;
}
.td-compose-text::placeholder { color: var(--shell-ink-60); }
.td-compose-text.td-wrong { border-color: var(--admin-wrong); box-shadow: 0 0 0 1px var(--admin-wrong); }
.td-compose-label { font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.td-compose-field .ad-label--plain { font-size: 12px; font-weight: 800; }
.td-compose-field .ad-input, .td-compose-field .ad-select { height: 34px; font-size: 13px; border-radius: 8px; padding: 0 10px; }
.td-compose .ad-field { gap: 4px; }
.td-compose .ad-label--plain { font-size: 12px; font-weight: 800; }
.td-compose input[type="date"] { height: 34px; font-size: 13px; border-radius: 8px; padding: 0 10px; }
.td-compose-pair { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 8px; }
.td-chips { display: flex; gap: 6px; flex-wrap: wrap; }
.td-aud {
  height: 30px; padding: 0 10px; border-radius: 7px; border: 1.5px solid var(--shell-ink-14); background: var(--shell-bg);
  color: var(--shell-ink); font-weight: 700; font-size: 12px; display: inline-flex; align-items: center; gap: 6px; font-family: inherit; cursor: pointer;
}
.td-aud[aria-checked="true"] { border-color: var(--shell-ink); }
.td-post { align-self: flex-start; }

.td-coming { display: flex; flex-direction: column; gap: 14px; }
.td-coming-row { display: flex; gap: 12px; align-items: center; }
.td-date {
  width: 48px; flex-shrink: 0; display: flex; flex-direction: column; align-items: center; padding: 6px 0; border-radius: 8px;
  background: var(--shell-ink-04);
}
.td-date-dow, .td-date-mon { font-size: 10px; font-weight: 800; letter-spacing: 0.08em; color: var(--shell-ink-60); }
.td-date-day { font-size: 18px; font-weight: 800; line-height: 1.15; }
.td-coming-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.td-coming-title { display: flex; align-items: center; gap: 7px; font-size: 14px; font-weight: 700; line-height: 1.4; }
.td-coming-detail { font-size: 13px; line-height: 1.45; color: var(--shell-ink-60); overflow-wrap: anywhere; }

.td-list { display: flex; flex-direction: column; gap: 12px; }
.td-list-row { display: flex; flex-direction: column; gap: 2px; padding: 10px 12px; border-radius: 9px; background: var(--shell-ink-03); }
.td-list-name { font-size: 14px; font-weight: 700; color: var(--shell-ink); text-decoration: none; align-self: flex-start; }
.td-list-name:hover { text-decoration: underline; }
.td-list-why { font-size: 13px; line-height: 1.45; color: var(--shell-ink-62); }

/* ---- Between laptop and phone: 1 column ----------------------------------------------------------- */
@media (max-width: 1100px) {
  .td-grid { grid-template-columns: minmax(0, 1fr); }
  .td-new-row { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto; }
}

/* ---- Phone (answer 5) ---------------------------------------------------------------------------- */
@media (max-width: 760px) {
  .td-page { gap: 18px; }
  .td-grid, .td-col { gap: 18px; }
  .td-live { flex-direction: column; align-items: stretch; padding: 20px 18px; }
  .td-live-title { font-size: 19px; }
  .td-live-btn { width: 100%; }
  .td-card-head { padding: 16px; }
  .td-empty, .td-pad { padding: 16px; }
  .td-job { flex-wrap: wrap; gap: 12px; padding: 16px; }
  .td-job-main { flex-basis: calc(100% - 38px); }
  .td-job-acts { max-width: none; width: 100%; padding-left: 38px; justify-content: flex-start; }
  .td-job-link, .td-job-btn { flex: 1 1 auto; height: 40px; }
  .td-new-row { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; padding: 14px 16px; }
  .td-new-when { justify-self: auto; }
  .td-side { padding: 18px 16px; }
  .td-compose-pair { grid-template-columns: minmax(0, 1fr); }
  .td-compose-text { font-size: 16px; }
  .td-compose-field .ad-input, .td-compose-field .ad-select, .td-compose input[type="date"] { font-size: 16px; height: 40px; }
  /* every control at least 24px to tap (item 178): the tick boxes, in the same 26px column, and the names */
  .td-tick { width: 24px; height: 24px; margin: 0 1px; }
  .td-new-name, .td-list-name { display: inline-flex; align-items: center; min-height: 24px; }
}
